import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "enableExpansionHandle", "expanded", "children", "primary", "secondary", "tertiary", "depthLevel", "tag", "selected"];
import React, { forwardRef } from 'react';
import { useComponentTheme } from '../../../utils/hooks';
import { useMenuElementClassNames } from './utils/useMenuElementClassNames';
import { MenuElementRoot, MenuElementContent, MenuElementExpansionHandle, MenuElementExpansionHandleArrow } from './style';
import { menuElementDefaultTheme } from './theme';
import { MENU_ELEMENT_CLASS_PREFIX } from './constants';
export var MenuElement = forwardRef(function MenuElement(_ref, ref) {
  var className = _ref.className,
      enableExpansionHandle = _ref.enableExpansionHandle,
      expanded = _ref.expanded,
      children = _ref.children,
      primary = _ref.primary,
      secondary = _ref.secondary,
      tertiary = _ref.tertiary,
      depthLevel = _ref.depthLevel,
      _ref$tag = _ref.tag,
      Tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      selected = _ref.selected,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var theme = useComponentTheme(MENU_ELEMENT_CLASS_PREFIX, menuElementDefaultTheme);
  var classNameComponents = useMenuElementClassNames(MENU_ELEMENT_CLASS_PREFIX, className);
  return React.createElement(MenuElementRoot, Object.assign({}, restProps, {
    primary: primary,
    secondary: secondary,
    tertiary: tertiary,
    depthLevel: depthLevel,
    enableExpansionHandle: enableExpansionHandle,
    expanded: expanded,
    selected: selected,
    theme: theme,
    className: classNameComponents.Root,
    "aria-expanded": expanded ? 'true' : 'false',
    "data-expanded": expanded ? '1' : '0',
    "data-selected": selected ? '1' : '0'
  }), function (forwardedProps) {
    return React.createElement(Tag, Object.assign({}, forwardedProps, {
      ref: ref
    }), React.createElement(MenuElementContent, {
      theme: theme,
      className: classNameComponents.Content
    }, children), enableExpansionHandle && React.createElement(MenuElementExpansionHandle, {
      theme: theme,
      className: classNameComponents.ExpansionHandle,
      primary: primary,
      secondary: secondary,
      tertiary: tertiary,
      depthLevel: depthLevel
    }, React.createElement(MenuElementExpansionHandleArrow, {
      expanded: expanded,
      theme: theme,
      className: classNameComponents.ExpansionHandleArrow
    })));
  });
});
MenuElement.defaultProps = {
  primary: false,
  secondary: false,
  tertiary: false,
  selected: false,
  enableExpansionHandle: false,
  expanded: false
};